import DefaultRedirectPage from '../pages/DefaultRedirect/DefaultRedirectPage';
import LoginPage from '../pages/Login/LoginPage';
import PublicLayout from '../layouts/publicLayout';
import RegisteredLayout from '../layouts/registered';
import AppSettingPage from '../pages/AppSetting/AppSettingPage';
import EmptyLayout from '../layouts/emptyLayout';
import ResetPasswordContentPage from '../pages/ResetPassword/ResetPasswordContentPage';
import SetPasswordContentPage from '../pages/SetPassword/SetPasswordPage';
import ProfilePage from '../pages/Profile/ProfilePage';
import { EnumsValues } from '../enums/EnumsValues';
import RolePage from '../pages/Role/RolePage';
import PermissionPage from '../pages/Permission/PermissionPage';
import UserPage from '../pages/User/UserPage';
import { IRouteConfig } from '../interfaces/routeConfig';
import Generate2FA from '../pages/Totp2FA/Generate2FA/Generate2FA';
import Validate2FA from '../pages/Totp2FA/Validate2FA/Validate2FA';
import Config2FA from '../pages/Totp2FA/Config2FA/Config2FA';
import TenantPage from '../pages/Tenant/TenantPage';
import Receipt from '../pages/Receipt/Receipt';
import { CompleteRegisterPage } from '../pages/CompleteRegister/CompleteRegisterPage';
import { RegisterPage } from '../pages/Register/RegisterPage';
import { TenantEditPage } from '../pages/TenantEdit/TenantEditPage';
import { DataRelationPage } from '../pages/DataRelation/DataRelationPage';
import { Indicators } from '../pages/Indicators/Indicators';
import { PacksPage } from '../pages/PacksPage/PacksPage';
import { MethodsPage } from '../pages/Methods/MethodsPage';
import TwoFALayout from '../layouts/TwoFALayout/TwoFALayout';
import { WizardLayout } from '../layouts/WizardLayout/WizardLayout';
import { BillingFormPage } from '../pages/BillingFormPage/BillingFormPage';
import InvitationPage from '../pages/Invitation/Invitation';
import { TermsAndConditions } from '../pages/TermsAndConditions/TermsAndConditions';
import Product from '../pages/Product/Product';
import { SelectTenant } from '../pages/SelectTenant/SelectTenant';
import { ReviewReceipt } from '../pages/ReviewReceipt/ReviewReceipt';
import HomePage from '../pages/Home/HomePage';
import { Redirect } from 'react-router';
import { EmailReception } from '../pages/EmailReception/EmailReception';
import { TenantSetting } from '../pages/TenantSetting/TenantSetting';
import { ManageTenantSettings } from '../pages/TenantSetting/ManageTenantSettings';
import ReceiptLogs from '../pages/ReceiptLogs/ReceiptLogs';
import { ValidateEmailPage } from '../pages/ValidateEmail/ValidateEmailPage';
import { Concepts } from '../pages/Concepts/Concepts';
import ValidationSettings from '../pages/ValidationSetting/ValidationSettings';
import TenantEditAdmin from '../pages/TenantEditAdmin/TenantEditAdmin';
import WaybillPage from '../pages/WaybillPage/WaybillPage';
import DeliveryNotePage from '../pages/DeliveryNotePage/DeliveryNotePage';
import Summary from '../pages/Workflows/Summary';
import MyProcesses from '../pages/Workflows/MyProcesses';
import HelpPage from '../pages/HelpPage/HelpPage';

const routes: IRouteConfig[] = [
  {
    path: '/',
    exact: true,
    component: DefaultRedirectPage,
    key: 'defaultRedirect',
  },
  {
    path: '/invitation',
    component: InvitationPage,
    key: 'invitation',
  },
  {
    path: '/termsandconditions',
    exact: true,
    component: TermsAndConditions,
    key: 'termsandconditions',
  },
  {
    path: '/wizard',
    name: 'Wizard',
    component: WizardLayout,
    key: 'wizard',
    routes: [
      {
        path: '/wizard/packs',
        component: PacksPage,
        name: 'Packs de créditos',
        key: 'packsPage',
      },
      {
        path: '/wizard/integration',
        component: MethodsPage,
        name: 'Integración',
        key: 'integrationPage',
      },
      {
        path: '/wizard/billingForm',
        component: BillingFormPage,
        name: 'Facturación',
        key: 'billingFormPage',
      },
      {
        path: '*',
        component: () => <Redirect to="/" />,
        key: 'defaultRedirectWizardLayout',
        hideInMenu: true,
      },
    ],
  },
  {
    path: '/app',
    component: RegisteredLayout,
    key: 'app',
    routes: [
      {
        path: '/app/config2fa',
        component: Config2FA,
        key: 'config2fa',
        translation_key: 'page.config2fa',
        hideInMenu: true,
      },
      {
        path: '/app/home',
        component: HomePage,
        name: 'Inicio',
        icon: (
          <span
            className="material-symbols-outlined sideMenu-icon"
            translate="no"
          >
            home
          </span>
        ),
        key: 'inicio',
        translation_key: 'page.home',
        requiresTenantSelected: true,
      },
      {
        path: '/app/smartDocs',
        name: 'SmartDocs',
        component: EmptyLayout,
        icon: (
          <span
            className="material-symbols-outlined sideMenu-icon"
            translate="no"
          >
            description
          </span>
        ),
        authority: EnumsValues.Functions.ListReceiptHeader,
        key: 'smartDocs',
        translation_key: 'page.smartDocs',
        routes: [
          {
            path: '/app/smartDocs/documents',
            name: 'Documentos',
            component: EmptyLayout,
            authority: EnumsValues.Functions.ListReceiptHeader,
            key: 'Documentos',
            translation_key: 'page.documents',
            routes: [
              {
                path: '/app/smartDocs/documents/receipt/reviewReceipt/:receipt_id',
                exact: true,
                name: 'Revisor',
                component: ReviewReceipt,
                key: 'reviewReceipt',
                translation_key: 'page.reviewReceipt',
                authority: EnumsValues.Functions.ListReceiptHeader,
                requiresTenantSelected: true,
                hideInMenu: true,
              },
              {
                path: '/app/smartDocs/documents/receipt/viewLogs/:receipt_id',
                exact: true,
                name: 'Historial',
                component: ReceiptLogs,
                key: 'receiptLogs',
                translation_key: 'page.receiptLogs',
                authority: EnumsValues.Functions.LogRead,
                requiresTenantSelected: true,
                hideInMenu: true,
              },
              {
                path: '/app/smartDocs/documents/receipt',
                exact: true,
                component: Receipt,
                name: 'Comprobantes',
                authority: EnumsValues.Functions.ListReceiptHeader,
                key: 'receipt',
                translation_key: 'page.receipt',
                requiresTenantSelected: true,
                className: 'receiptMenuPage',
              },
              {
                path: '/app/smartDocs/documents/waybill',
                component: WaybillPage,
                name: 'Cartas de porte',
                authority: EnumsValues.Functions.ListReceiptHeader,
                key: 'waybill',
                translation_key: 'page.waybill',
                requiresTenantSelected: true,
                featureFlag: EnumsValues.FeatureFlags.waybillPage,
              },
              {
                path: '/app/smartDocs/documents/deliveryNote',
                component: DeliveryNotePage,
                name: 'Remito',
                authority: EnumsValues.Functions.ListReceiptHeader,
                key: 'deliveryNote',
                translation_key: 'page.deliveryNote',
                requiresTenantSelected: true,
                featureFlag: EnumsValues.FeatureFlags.deliveryNotePage,
              },
            ],
          },
          {
            path: '/app/smartDocs/packs',
            component: PacksPage,
            name: 'Créditos',
            featureFlag: EnumsValues.FeatureFlags.packsPage,
            key: 'packsPage',
            translation_key: 'page.packsPage',
            requiresTenantSelected: true,
            className: 'packsMenuPage',
          },
          {
            path: '/app/smartDocs/administration',
            name: 'Administración',
            component: EmptyLayout,
            authority: EnumsValues.Functions.AdministrationMenuRead,
            key: 'administration',
            translation_key: 'page.administration',
            routes: [
              {
                path: '/app/smartDocs/administration/concepts',
                component: Concepts,
                authority: EnumsValues.Functions.ReadConceptMaster,
                name: 'Conceptos',
                key: 'conceptsPage',
                translation_key: 'page.concepts',
                requiresTenantSelected: true,
              },
              {
                path: '/app/smartDocs/administration/product',
                component: Product,
                authority: EnumsValues.Functions.CreateProduct,
                name: 'Productos',
                key: 'productPage',
                translation_key: 'page.product',
                requiresTenantSelected: true,
              },
              {
                path: '/app/smartDocs/administration/data_relation',
                component: DataRelationPage,
                name: 'Relación de datos',
                authority: EnumsValues.Functions.ReadDecisionItem,
                key: 'dataRelationPage',
                translation_key: 'page.dataRelation',
                requiresTenantSelected: true,
              },
              {
                path: '*',
                component: () => <Redirect to="/" />,
                key: 'defaultRedirectEmptyLayoutAdministration',
                hideInMenu: true,
              },
            ],
          },
          {
            path: '/app/smartDocs/setting',
            component: EmptyLayout,
            name: 'Configuración',
            authority: EnumsValues.Functions.ConfigurationMenuRead,
            key: 'setting',
            translation_key: 'page.setting',
            routes: [
              {
                path: '/app/smartDocs/setting/validations',
                component: ValidationSettings,
                authority:
                  EnumsValues.Functions
                    .UpdateDocumentTypeBusinessValidationTenant,
                name: 'validationSetting',
                key: 'validationSetting',
                translation_key: 'page.validationSettings',
                featureFlag:
                  EnumsValues.FeatureFlags.controlsAndValidationsPage,
              },
              {
                path: '/app/smartDocs/setting/general',
                component: TenantSetting,
                authority: EnumsValues.Functions.UpdateTenantSetting,
                name: 'General',
                key: 'general',
                translation_key: 'page.general',
              },
              {
                path: '/app/smartDocs/setting/emailReception',
                component: EmailReception,
                authority: EnumsValues.Functions.GetTenantEmailReceipt,
                featureFlag: EnumsValues.FeatureFlags.emailReception,
                name: 'emailReception',
                key: 'emailReception',
                translation_key: 'page.emailReception',
              },
              {
                path: '/app/smartDocs/setting/integration',
                name: 'Integración',
                component: MethodsPage,
                key: 'integration',
                translation_key: 'page.integration',
                featureFlag: EnumsValues.FeatureFlags.methodsPage,
                requiresTenantSelected: true,
              },
              {
                path: '/app/smartDocs/setting/manageTenantSettings',
                component: ManageTenantSettings,
                authority: EnumsValues.Functions.UpdateTenantSettingVisibility,
                name: 'Administrar tenant settings',
                key: 'manageTenantSettings',
                translation_key: 'page.manageTenantSettings',
              },
            ],
          },
        ],
      },

      {
        path: '/app/indicators',
        component: Indicators,
        name: 'Indicadores',
        icon: (
          <span
            className="material-symbols-outlined sideMenu-icon"
            translate="no"
          >
            bar_chart
          </span>
        ),
        authority: EnumsValues.Functions.GetReceiptHeaderToIndicator,
        key: 'indicators',
        translation_key: 'page.indicators',
        requiresTenantSelected: true,
        hideInMenu: true,
      },
      {
        path: '/app/flowDesk',
        name: 'FlowDesk',
        component: EmptyLayout,
        icon: (
          <span
            className="material-symbols-outlined sideMenu-icon"
            translate="no"
          >
            account_tree
          </span>
        ),
        featureFlag: EnumsValues.FeatureFlags.workflowPage,
        // authority: EnumsValues.Functions.AdministrationMenuRead,
        key: 'flow',
        translation_key: 'page.workflow',
        routes: [
          {
            path: '/app/flowDesk/summary',
            component: Summary,
            // authority: EnumsValues.Functions.ReadConceptMaster,
            name: 'Resumen',
            key: 'summaryPage',
            translation_key: 'page.summary',
            requiresTenantSelected: true,
          },
          {
            path: '/app/flowDesk/activities',
            component: MyProcesses,
            // authority: EnumsValues.Functions.ReadConceptMaster,
            name: 'Mis actividades',
            key: 'activitiesPage',
            translation_key: 'page.activities',
            requiresTenantSelected: true,
          },
          {
            path: '/app/flowDesk/myFlows',
            component: MyProcesses,
            authority: EnumsValues.Functions.FlowDeskInitiator,
            name: 'Mis flujos',
            key: 'processesPage',
            translation_key: 'page.myFlows',
            requiresTenantSelected: true,
          },
        ],
      },

      {
        path: '/app/organization',
        component: EmptyLayout,
        name: 'Organización',
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="14"
            viewBox="0 0 16 14"
            fill="none"
          >
            <path
              d="M3.46208 9.85104C3.10917 9.85104 2.80826 9.72486 2.55938 9.4725C2.31035 9.22028 2.18583 8.91708 2.18583 8.56292C2.18583 8.20264 2.31194 7.89938 2.56417 7.65313C2.81653 7.40688 3.11979 7.28375 3.47396 7.28375C3.8259 7.28375 4.12576 7.40833 4.37354 7.6575C4.62132 7.90667 4.74521 8.21007 4.74521 8.56771C4.74521 8.92535 4.61951 9.22861 4.36812 9.4775C4.11687 9.72653 3.81486 9.85104 3.46208 9.85104ZM12.1254 9.85104C11.7725 9.85104 11.4716 9.72486 11.2227 9.4725C10.9738 9.22028 10.8494 8.91708 10.8494 8.56292C10.8494 8.20264 10.9755 7.89938 11.2277 7.65313C11.4799 7.40688 11.7831 7.28375 12.1373 7.28375C12.4894 7.28375 12.7893 7.40833 13.0371 7.6575C13.2847 7.90667 13.4085 8.21007 13.4085 8.56771C13.4085 8.92535 13.2829 9.22861 13.0317 9.4775C12.7804 9.72653 12.4783 9.85104 12.1254 9.85104ZM7.81792 8.86687C7.32611 8.86687 6.90708 8.69569 6.56083 8.35333C6.21472 8.01097 6.04167 7.59188 6.04167 7.09604C6.04167 6.59618 6.21285 6.17451 6.55521 5.83104C6.89757 5.48743 7.31667 5.31563 7.8125 5.31563C8.30181 5.31563 8.72083 5.48583 9.06958 5.82625C9.41847 6.16667 9.59292 6.58549 9.59292 7.08271C9.59292 7.57993 9.42007 8.0016 9.07438 8.34771C8.72868 8.69382 8.30986 8.86687 7.81792 8.86687ZM4.3525 13.6667C4.41667 12.75 4.77722 11.9789 5.43417 11.3533C6.09111 10.7278 6.88514 10.415 7.81625 10.415C8.7475 10.415 9.54056 10.7278 10.1954 11.3533C10.8504 11.9789 11.2099 12.75 11.274 13.6667H4.3525ZM0.717917 13.6667C0.717917 12.8974 0.984236 12.2465 1.51688 11.714C2.04938 11.1813 2.70028 10.915 3.46958 10.915C3.64181 10.915 3.80396 10.9316 3.95604 10.9648C4.10799 10.9978 4.26097 11.0475 4.415 11.1137C4.12514 11.4683 3.89056 11.8631 3.71125 12.2979C3.53194 12.7328 3.42979 13.189 3.40479 13.6667H0.717917ZM12.2179 13.6667C12.1954 13.1838 12.0982 12.7254 11.9263 12.2917C11.7542 11.8579 11.5202 11.4626 11.2244 11.1058C11.3702 11.0449 11.5203 10.9978 11.6748 10.9648C11.8294 10.9316 11.9821 10.915 12.1329 10.915C12.9022 10.915 13.5531 11.1813 14.0856 11.714C14.6183 12.2465 14.8846 12.8974 14.8846 13.6667H12.2179ZM0.660208 6.82688L0 5.97604L7.81729 0L11.8092 3.05458V1H13.3846V4.24687L15.6346 5.97604L14.9663 6.82688L7.81729 1.36687L0.660208 6.82688Z"
              fill="white"
            />
          </svg>
        ),
        authority: EnumsValues.Functions.ConfigurationMenuRead,
        key: 'organization',
        translation_key: 'page.organization',
        routes: [
          {
            path: '/app/organization/tenant',
            component: TenantEditPage,
            authority: EnumsValues.Functions.TenantUpdate,
            name: 'Mi organización',
            key: 'tenantEdit',
            translation_key: 'page.myOrganization',
            requiresTenantSelected: true,
          },
          {
            path: '/app/organization/user',
            component: UserPage,
            authority: EnumsValues.Functions.UserList,
            name: 'Usuarios',
            key: 'user',
            translation_key: 'page.user',
            requiresTenantSelected: true,
          },
          {
            path: '/app/organization/system',
            component: AppSettingPage,
            authority: EnumsValues.Functions.AppSettingRead,
            name: 'System',
            key: 'system',
            translation_key: 'page.system',
          },

          {
            path: '/app/organization/permission',
            component: PermissionPage,
            authority: EnumsValues.Functions.PermissionList,
            name: 'Permisos',
            key: 'permission',
            translation_key: 'page.permission',
          },
          {
            path: '/app/organization/role',
            component: RolePage,
            authority: EnumsValues.Functions.UserRoleList,
            name: 'Roles',
            key: 'role',
            translation_key: 'page.role',
          },
          {
            path: '/app/organization/tenants',
            component: TenantPage,
            authority: EnumsValues.Functions.AdministrationTenantRead,
            name: 'Cuentas comerciales',
            key: 'tenant',
            translation_key: 'page.tenant',
            exact: true,
          },
          {
            path: '/app/organization/tenants/create',
            component: TenantEditAdmin,
            authority: EnumsValues.Functions.AdministrationTenantRead,
            name: 'TODO',
            key: 'tenantCreateAdmin',
            translation_key: 'page.tenantCreateAdmin',
            hideInMenu: true,
          },
          {
            path: '/app/organization/tenants/edit/:tenant_id',
            component: TenantEditAdmin,
            authority: EnumsValues.Functions.AdministrationTenantRead,
            name: 'TODO',
            key: 'tenantEditAdmin',
            translation_key: 'page.tenantEditAdmin',
            hideInMenu: true,
          },
        ],
      },
      {
        path: '/app/help',
        component: HelpPage,
        name: 'Ayuda',
        icon: (
          <span
            className="material-symbols-outlined sideMenu-icon"
            translate="no"
          >
            help
          </span>
        ),
        key: 'ayuda',
        translation_key: 'page.help',
        requiresTenantSelected: true,
      },
      {
        path: '/app/profile',
        // authority: EnumsValues.Functions.AppSettingRead,
        component: ProfilePage,
        name: 'Mi perfil',
        hideInMenu: true,
        key: 'profile',
        translation_key: 'page.profile',
      },
      {
        path: '/app/selectTenant',
        component: SelectTenant,
        hideInMenu: true,
        key: 'selectTenant',
      },
      {
        path: '*',
        component: () => <Redirect to="/" />,
        key: 'defaultRedirectRegisteredLayout',
        hideInMenu: true,
      },
    ],
  },

  {
    path: '/2fa',
    component: TwoFALayout,
    key: 'twoFALayout',
    routes: [
      {
        path: '/2fa/generate',
        exact: true,
        component: Generate2FA,
        key: 'generate',
      },
      {
        path: '/2fa/validateTotp',
        exact: true,
        component: Validate2FA,
        key: 'validateTotp',
      },
      {
        path: '*',
        component: () => <Redirect to="/" />,
        key: 'defaultRedirectTwoFALayout',
        hideInMenu: true,
      },
    ],
  },
  {
    path: '/',
    component: PublicLayout,
    key: 'publicLayout',
    routes: [
      {
        path: '/resetPassword',
        exact: true,
        component: ResetPasswordContentPage,
        key: 'resetPassword',
      },
      {
        exact: true,
        path: '/setPassword',
        component: SetPasswordContentPage,
        key: 'setPassword',
      },
      {
        exact: true,
        path: '/completeRegister',
        component: CompleteRegisterPage,
        key: 'completeRegister',
      },
      {
        exact: true,
        path: '/validateEmail',
        component: ValidateEmailPage,
        key: 'validateEmail',
      },
      {
        path: '/login',
        exact: true,
        component: LoginPage,
        key: 'login',
      },
      {
        path: '/register',
        exact: true,
        component: RegisterPage,
        key: 'register',
      },
      {
        path: '*',
        component: () => <Redirect to="/" />,
        key: 'defaultRedirectPublicLayout',
        hideInMenu: true,
      },
    ],
  },
];

export default routes;
